import React, { useState, useEffect } from "react";
import {
    Box,
    Button,
    Card,
    CardContent,
    FormControlLabel,
    Grid,
    Paper,
    Snackbar,
    Alert,
    Switch,
    TextField,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    IconButton,
    MenuItem
} from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import VehiclesServices from "../../services/VehicleService";
import DeleteIcon from "@mui/icons-material/Delete";

const CreateVehicleMaker = () => {
    const [vehicleMakes, setVehicleMakes] = useState([]);
    const [formData, setFormData] = useState({
        make: "",
        status: "active"
    });

    const [errors, setErrors] = useState({});

    const [snackbar, setSnackbar] = useState({
        open: false,
        message: "",
        severity: "success"
    });

    const handleChange = (e) => {
        const { name, value, checked, type } = e.target;

        setFormData({
            ...formData,
            [name]: type === "checkbox" ? checked : value
        });

        setErrors({
            ...errors,
            [name]: ""
        });
    };

    const validate = () => {
        let temp = {};

        if (!formData.make.trim()) {
            temp.make = "Vehicle Make Name is required";
        }

        setErrors(temp);

        return Object.keys(temp).length === 0;
    };

    const fetchVehicleMakes = async () => {
        try {
            const response = await VehiclesServices.getVehicleMakeList();
            setVehicleMakes(response.data);
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        fetchVehicleMakes();
    }, []);

    const handleSave = async () => {
        if (!validate()) return;

        try {
            const payload = {
                make: formData.make.trim(),
            };

            const response = await VehiclesServices.createVehicleMake(payload);

            if (response.status === 200 || response.status === 201) {
                setSnackbar({
                    open: true,
                    message: "Vehicle Make created successfully.",
                    severity: "success",
                });

                setFormData({
                    make: "",
                    status: true,
                });
                fetchVehicleMakes();
            }
        } catch (error) {
            setSnackbar({
                open: true,
                message:
                    error?.response?.data?.message ||
                    error?.response?.data?.detail ||
                    "Failed to create Vehicle Make.",
                severity: "error",
            });
        }
    };


    const handleDelete = async (id) => {
        try {
            await VehiclesServices.deleteVehicleMake(id);

            setSnackbar({
                open: true,
                message: "Vehicle Make deleted successfully.",
                severity: "success",
            });

            fetchVehicleMakes();

        } catch (error) {

            console.log(error);

            setSnackbar({
                open: true,
                message:
                    error?.response?.data?.message ||
                    "Failed to delete Vehicle Make.",
                severity: "error",
            });

        }
    };

    const handleReset = () => {
        setFormData({
            make: "",
            status: true
        });

        setErrors({});
    };

    return (
        <Box p={3}>
            <Paper elevation={3}>
                <Card>
                    <CardContent>

                        <Typography
                            variant="h5"
                            fontWeight={600}
                            gutterBottom
                            sx={{ mb: 2 }}
                        >
                            Create Vehicle Make
                        </Typography>


                        <Grid container spacing={3}>

                            <Grid item xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    required
                                    label="Vehicle Maker Name"
                                    name="make"
                                    value={formData.make}
                                    onChange={handleChange}
                                    error={Boolean(errors.make)}
                                    helperText={errors.make}
                                    placeholder="e.g. Tata Motors"
                                />
                            </Grid>

                            {/* <Grid item xs={12} md={6}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={formData.status}
                      onChange={handleChange}
                      name="status"
                    />
                  }
                  label={formData.status ? "Active" : "Inactive"}
                />
              </Grid> */}

                        </Grid>

                        <Box
                            mt={4}
                            display="flex"
                            gap={2}
                        >
                            <Button
                                variant="contained"
                                startIcon={<SaveIcon />}
                                onClick={handleSave}
                            >
                                Save
                            </Button>

                            <Button
                                variant="outlined"
                                color="warning"
                                startIcon={<RestartAltIcon />}
                                onClick={handleReset}
                            >
                                Reset
                            </Button>


                        </Box>

                    </CardContent>
                </Card>
            </Paper>
            <Box mt={3}>
                <Paper elevation={3}>
                    <Card>
                        <CardContent>

                            <Typography
                                variant="h6"
                                fontWeight={600}
                                sx={{ mb: 2 }}
                            >
                                Vehicle Make List
                            </Typography>

                            <TableContainer>
                                <Table>

                                    <TableHead>
                                        <TableRow>
                                            <TableCell><strong>S.No</strong></TableCell>
                                            <TableCell><strong>Vehicle Make</strong></TableCell>
                                            <TableCell align="center"><strong>Action</strong></TableCell>
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>

                                        {vehicleMakes.length > 0 ? (
                                            vehicleMakes.map((item, index) => (
                                                <TableRow key={item.id}>
                                                    <TableCell>{item.id}</TableCell>

                                                    <TableCell>{item.make}</TableCell>

                                                    <TableCell align="center">
                                                        <IconButton
                                                            color="error"
                                                            onClick={() => handleDelete(item.id)}
                                                        >
                                                            <DeleteIcon />
                                                        </IconButton>
                                                    </TableCell>
                                                </TableRow>
                                            ))
                                        ) : (
                                            <TableRow>
                                                <TableCell
                                                    colSpan={3}
                                                    align="center"
                                                >
                                                    No Vehicle Make Found
                                                </TableCell>
                                            </TableRow>
                                        )}

                                    </TableBody>

                                </Table>
                            </TableContainer>

                        </CardContent>
                    </Card>
                </Paper>
            </Box>

            <Snackbar
                open={snackbar.open}
                autoHideDuration={3000}
                onClose={() =>
                    setSnackbar({
                        ...snackbar,
                        open: false,
                    })
                }
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
            >
                <Alert
                    onClose={() =>
                        setSnackbar({
                            ...snackbar,
                            open: false,
                        })
                    }
                    severity={snackbar.severity}
                    variant="filled"
                    sx={{ width: "100%" }}
                >
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </Box>
    );
};

export default CreateVehicleMaker;